import React, { createContext, useContext, useMemo } from 'react';
import { Context } from './types';
import { useSelectState } from 'shared/hooks';

interface Props {
  children: React.ReactNode;
}

export const HistoryTargetDeviceContext = createContext({} as Context);
export const useHistoryTargetDeviceContext = () => useContext(HistoryTargetDeviceContext);

const HistoryTargetDeviceProvider = ({ children }: Props) => {
  const [historyTarget, setHistoryTarget] = useSelectState();
  const value = useMemo(() => ({ historyTarget, setHistoryTarget }), [historyTarget, setHistoryTarget]);

  return <HistoryTargetDeviceContext.Provider value={value}>{children}</HistoryTargetDeviceContext.Provider>;
};

export default HistoryTargetDeviceProvider;
